module.exports = "/assets/data/248bfdb3c6589323b7eeeaeac15914df-BH24.data.json";